/** Announcement badge formatting and draft validation shared by the two views. */

export const ANNOUNCEMENT_TITLE_MAX = 200
export const ANNOUNCEMENT_CONTENT_MAX = 20000

/** Badge text for a menu unread count; '' means the badge must not render. */
export function formatUnreadBadge(count: number): string {
  if (!Number.isFinite(count) || count <= 0) return ''
  const value = Math.floor(count)
  return value > 99 ? '99+' : String(value)
}

/** Mirrors the server-side limits; returns '' when the draft passes. */
export function validateAnnouncementDraft(title: string, content: string): string {
  const trimmedTitle = title.trim()
  if (!trimmedTitle) return '请输入公告标题'
  if (trimmedTitle.length > ANNOUNCEMENT_TITLE_MAX) return `公告标题不能超过 ${ANNOUNCEMENT_TITLE_MAX} 字`
  const trimmedContent = content.trim()
  if (!trimmedContent) return '请输入公告正文'
  if (trimmedContent.length > ANNOUNCEMENT_CONTENT_MAX) return `公告正文不能超过 ${ANNOUNCEMENT_CONTENT_MAX} 字`
  return ''
}
